<div class="subscription-container">
  <div class="subscription-bg"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-10">
        <div class="subscription-card">
          <!-- Logo & Header -->
          <div class="card-header">
            <div class="logo-container">
              <img src="assets/images/am_logo_transparent.png" alt="Arthur Murray Dance Centers" class="logo">
            </div>
            <h1 class="main-title">Welcome to Agenda Master</h1>
            <p class="subtitle">Your ultimate dance studio management solution</p>
          </div>

          <div class="card-content">
            <div class="row">
              <!-- Plan Info -->
              <div class="col-lg-7 mb-4 mb-lg-0">
                <div class="plan-info">
                  <div class="plan-badge">Professional Plan</div>
                  <h2 class="plan-title">Complete Studio Management Solution</h2>

                  <div class="price-container">
                    <div class="price">
                      <span class="currency">$</span>
                      <span class="amount">{{plan.price}}</span>
                      <span class="period">/month</span>
                    </div>
                    <span class="price-note">per studio location</span>
                  </div>

                  <div class="divider"></div>

                  <div class="features">
                    <h3 class="features-title">Everything you need to succeed</h3>
                    <div class="row features-grid">
                      <div class="col-md-6" *ngFor="let feature of plan.features">
                        <div class="feature-item">
                          <span class="feature-icon">
                            <i class="fas fa-check"></i>
                          </span>
                          <span class="feature-text">{{feature}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Action Panel -->
              <div class="col-lg-5">
                <div class="action-panel">
                  <div class="highlights">
                    <div *ngFor="let feature of features" class="highlight-item">
                      <div class="highlight-icon">
                        <i class="fas fa-{{feature.icon}}"></i>
                      </div>
                      <div class="highlight-content">
                        <h4 class="highlight-title">{{feature.title}}</h4>
                        <p class="highlight-text">{{feature.description}}</p>
                      </div>
                    </div>
                  </div>

                  <!-- Call to Action -->
                  <div class="cta-section">
                    <!-- Initial state -->
                    <div *ngIf="!clientSecret" class="cta-initial">
                      <button (click)="onSubscribe()" class="btn-primary" [disabled]="loading">
                        <span *ngIf="!loading">
                          Continue to Payment
                          <i class="fas fa-arrow-right ms-2"></i>
                        </span>
                        <span *ngIf="loading">
                          <div class="spinner-border spinner-border-sm me-2" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                          Processing
                        </span>
                      </button>

                      <div class="security-info">
                        <i class="fas fa-lock"></i>
                        <span>Payments processed securely via Stripe</span>
                      </div>
                    </div>

                    <!-- Payment Form state -->
                    <form *ngIf="clientSecret" (submit)="handleSubmit($event)" id="payment-form" class="payment-form">
                      <div id="payment-element" class="payment-element"></div>

                      <button type="submit" class="btn-primary" [disabled]="loading">
                        <span *ngIf="!loading">Complete Subscription</span>
                        <span *ngIf="loading">
                          <div class="spinner-border spinner-border-sm me-2" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                          Processing
                        </span>
                      </button>

                      <div *ngIf="errorMessage" class="error-message">
                        <i class="fas fa-exclamation-circle"></i>
                        <span>{{ errorMessage }}</span>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card-footer">
            <div class="support">
              <span>Need help?</span> Contact us at <a href="mailto:support&#64;arthurmurray.com">support&#64;arthurmurray.com</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
